import { connect } from 'react-redux';
import MultiSelectPillMenu from './MultiSelectPillMenu';

function mapStateToProps(state, ownProps) {
  const { selectedItemsIds, ...restOwnProps } = ownProps;

  return {
    ...restOwnProps,
    selectedItemsIdsSet: new Set(selectedItemsIds),
  };
}

export default connect(mapStateToProps)(MultiSelectPillMenu);
